import { render, staticRenderFns } from "./EnacAtplDashboardLevelReportEditCompetencies.vue?vue&type=template&id=54985ef5"
import script from "./EnacAtplDashboardLevelReportEditCompetencies.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardLevelReportEditCompetencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports